import {SpaceTr, Tr, TrSpace} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import {Creature} from "@/store/level/types";
import CreaturePanel from "@/scenes.ui/creature-panel";
import PlayerStore from "@/store/player";
import RewardedUtils from "@/utils/rewarded-utils";
import {RestoreOptions} from "@/store/player/types";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class HealthRestorePanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, ro: RestoreOptions, restoreCallback: () => unknown,
                advCallback: () => unknown) {
        super(scene, canvas, Tr('zdorove').toUpperCase());

        let unlockLabel = TextUtils.addTextAdvanced(scene, Tr('nashi.geroi.raneni.v.bojah'), 0, -60,
            '#716f6a', 12, 'normal', 350, 'center', 2, Fonts.ARIAL_MT);

        let rewardedEnabled: boolean = ro.rewardedEnable;

        let mainText = TextUtils.addTextByFamily(scene, Tr('vosstanovit.zdorove.vsem.gerojam'),
            0, rewardedEnabled ? 5 : 15, '#ffd465', 18, 'normal', 400, Fonts.MYRIADPRO_BOLD);

        if (rewardedEnabled) {
            let commentText1 = TextUtils.addTextByFamily(scene, Tr('w.rol'),
                -105, 75, '#939292', 12, 'normal', 400, Fonts.MYRIADPRO_REGULAR);
            let commentText2 = TextUtils.addTextByFamily(scene, Tr('4gems'),
                105, 75, '#939292', 12, 'normal', 400, Fonts.MYRIADPRO_REGULAR);
            let commentText3 = TextUtils.addTextByFamily(scene, TrSpace('do') + String(ro.rewardedWatchesMax) + SpaceTr('t.p.d') + ' (' + String(ro.rewardedWatchesToday) + ' / ' + String(ro.rewardedWatchesMax) +')',
                -105, 235, '#939292', 12, 'normal', 400, Fonts.MYRIADPRO_REGULAR);
            let rewardedButton = new SquareButton(this.scene, -105, 155, 0,
                Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.PLAY_REWARDED, '', false);
            this.add([commentText1, commentText2, commentText3, rewardedButton]);

            rewardedButton.setCallback(() => {
                if (this.isOnTop()) {
                    advCallback();
                }
            });
        }

        let okButton = new SquareButton(this.scene, rewardedEnabled ? 105 : 0, rewardedEnabled ? 155 : 150, 0,
            Keys.UI_ART_GREEN_BUTTON, undefined, Keys.IC_100_MITHRIL, Tr('vosstanovit'), false);

        let creatures: Creature[] = PlayerStore.getPlayer().creatures.slice(0, 6);

        let i = 0;
        for (let c of creatures) {
            this.addCreaturePanel(c, i, creatures.length);
            ++i;
        }

        this.add(okButton);

        let speedupPriceText = TextUtils.addText(scene, String(ro.price), okButton.x / CU.S, okButton.y / CU.S + 36, '#ffffff', 25, 'bold', 200);

        okButton.setCallback(() => {
            if (this.isOnTop()) {
                restoreCallback();
            }
        });

        this.add([unlockLabel, mainText, speedupPriceText]);
    }

    private addCreaturePanel(c: Creature, num: number, totalCount: number): void {
        const cellWidth = totalCount <= 3 ? 100 : 74;
        let startX = cellWidth / 2 - totalCount * cellWidth / 2;
        let creturePanel = new CreaturePanel(this.scene!, startX + num * cellWidth, -155, c, () => {}, true);
        creturePanel.setDepth(1000);
        SpriteUtils.scale(creturePanel, 0.8);
        this.add(creturePanel);

        creturePanel.setHealthVisible();
    }
}
